import request from '@/utils/request'

const api = {
  pageQuery: "/article/pageQuery",
  deleteInfo: "/article/deleteInfo",
  save: "/article/save",
  detail:"/article/detail",
  artCateTree: "/articleCate/getTree",
}

export default api

export function pageQuery(data){
  return request({
    url: api.pageQuery,
    method: 'post',
    data
  })
}

export function deleteInfo(data){
  return request({
    url: api.deleteInfo,
    method: 'post',
    data
  })
}

export function save(data){
  return request({
    url: api.save,
    method: 'post',
    data
  })
}

export function detail(data){
  return request({
    url: api.detail,
    method: 'post',
    data
  })
}
export function getArtCateTree(data){
  return request({
    url: api.artCateTree,
    method: 'post',
    data
  })
}




